export const dashTranslations = {
  spanish: {
    dashboard: {
      kpis: {
        title: "KPI's",
        items: [
          {
            alias: 'Bloques de alta prioridad',
            content: 'Cantidad de bloques atrasados y disponibles a ejecutar el día de hoy en ruta crítica.'
          },
          {
            alias: 'Días de atraso',
            content: 'Días de atraso generados por los desplazamientos en la obra.'
          },
          {
            aliasLeft: 'Avance real',
            aliasRight: 'Programado',
            contentLeft: 'Avance que se ha logrado en la obra hasta el momento actual.',
            contentRight: 'Avance que se espera que tenga la obra en el momento actual.'
          },
          {
            alias: 'Finalización a ritmo actual',
            content: 'Fecha de finalización de la obra a ritmo de trabajo actual.'
          },
          {
            alias: 'Fecha de finalización',
            content: 'Fecha de finalización de la obra para la etiqueta seleccionada.'
          },
          {
            alias: 'Finalización a máximo esfuerzo',
            content: 'Fecha de finalización de la obra para la etiqueta seleccionada.'
          },
          {
            alias: 'Días de adelanto',
            content: 'Días de adelanto generados por los desplazamientos en la obra.'
          }
        ]
      },
      chart: {
        title: 'Avance general de obra'
      },
      specialityAdv: {
        title: 'Avance por especialidad'
      }
    },
    gantt: {
      title: 'Gantt',
      worktableLabel: 'Worktable',
      dateTypeLabel: 'Tipo de fecha',
      scheduled: 'Programada',
      rescheduled: 'Reprogramada',
      noWorktables: 'No hay worktables disponibles',
      selectWorktable: 'Seleccioná un worktable para visualizar el Gantt.',
      noData: 'No hay datos para mostrar.',
      error: 'Ocurrió un error al cargar los datos del Gantt.',
      code: 'Código',
      name: 'Descripción',
      start: 'Inicio',
      end: 'Fin',
      scaleLabel: 'Escala temporal',
      scaleDay: 'Día',
      scaleWeek: 'Semana',
      scaleMonth: 'Mes',
      scaleYear: 'Año'
    }
  },
  english: {
    dashboard: {
      kpis: {
        title: "KPI's",
        items: [
          {
            alias: 'High priority blocks',
            content: 'Number of delayed and available blocks to be executed today on the critical path.'
          },
          {
            alias: 'Delayed days',
            content: 'Delay days due to displacements at work.'
          },
          {
            aliasLeft: 'Real progress',
            aliasRight: 'Scheduled',
            contentLeft: 'Progress which has been achieved at work to date.',
            contentRight: 'Progress that the work is expected to have at present.'
          },
          {
            alias: 'Completion at current pace',
            content: 'Completion date of the work at current work rate.'
          },
          {
            alias: 'Completion date',
            content: 'Completion date of the work for the selected tag.'
          },
          {
            alias: 'Completion at max effort',
            content: 'Completion date of the work for the selected tag.'
          },
          {
            alias: 'Days in advance',
            content: 'Days in advance due to job displacement.'
          }
        ]
      },
      chart: {
        title: 'Work general progress'
      },
      specialityAdv: {
        title: 'Advancement by specialty'
      }
    },
    gantt: {
      title: 'Gantt',
      worktableLabel: 'Worktable',
      dateTypeLabel: 'Date type',
      scheduled: 'Scheduled',
      rescheduled: 'Rescheduled',
      noWorktables: 'No worktables available',
      selectWorktable: 'Select a worktable to display the Gantt.',
      noData: 'No data to display.',
      error: 'An error occurred while loading the Gantt data.',
      code: 'Code',
      name: 'Description',
      start: 'Start',
      end: 'End',
      scaleLabel: 'Time scale',
      scaleDay: 'Day',
      scaleWeek: 'Week',
      scaleMonth: 'Month',
      scaleYear: 'Year'
    }
  }
}

export const dtTranslations = {
  spanish: {
    filter: {
      action: 'Filtrar',
      header: 'Filtre por etiquetas los bloques que desea visualizar',
      dates: {
        title: 'Fechas',
        from: 'Desde',
        to: 'Hasta'
      },
      titles: ['Especialidades', 'Fases', 'Niveles', 'Otras'],
      buttons: [
        'Limpiar',
        'Filtrar'
      ]
    },
    sequence: {
      action: 'Secuencia'
    },
    specialties: {
      action: 'Especialidad',
      header: 'Seleccione las especialidades que desea visualizar',
      onClose: [
        'Cerrar',
        'Seleccionar'
      ]
    },
    visibility: {
      action: 'Estado',
      onClose: [
        'Cerrar',
        'Seleccionar'
      ]
    },
    modelSelection: {
      action: 'Nube',
      title: 'Seleccione el modelo que desea ver',
      buttons: [
        'Descargar',
        'Aplicar'
      ]
    },
    localModelSelection: {
      action: 'Local',
      title: 'Seleccione el modelo que desea ver',
      buttons: [
        'Cargar',
        'Aplicar'
      ],
      placeholder: 'Cargá un modelo local'
    }
  },
  english: {
    filter: {
      action: 'Filter',
      header: 'Filter by tags the blocks you want to visualize',
      dates: {
        title: 'Dates',
        from: 'From',
        to: 'To'
      },
      titles: ['Specialties', 'Phases', 'Contractors', 'Others'],
      buttons: [
        'Clear',
        'Filter'
      ]
    },
    sequence: {
      action: 'Sequence'
    },
    specialties: {
      action: 'Specialty',
      header: 'Select the specialties you want to visualize',
      onClose: [
        'Close',
        'Select'
      ]
    },
    visibility: {
      action: 'Status',
      onClose: [
        'Close',
        'Select'
      ]
    },
    modelSelection: {
      action: 'Cloud',
      title: 'Select the model you want to see',
      buttons: [
        'Download',
        'Apply'
      ]
    },
    localModelSelection: {
      action: 'Local',
      title: 'Select the model you want to see',
      buttons: [
        'Load',
        'Apply'
      ],
      placeholder: 'Load a local model'
    }
  }
}

export const blockModalTranslations = {
  spanish: {
    title: [
      'Bloque',
      'Descripción'
    ],
    tabs: {
      overview: 'Resumen',
      library: 'Archivos'
    },
    table: {
      item_0: 'Alias',
      item_1: 'Fecha de inicio programada',
      item_9: 'Fecha de fin programada',
      item_10: 'Fecha de inicio reprogramada',
      item_2: 'Fecha de fin reprogramada',
      item_3: 'Fecha de ejecución de avance',
      item_4: 'Atraso en días',
      item_5: 'Ejecución física',
      item_6: 'DSP',
      item_7: 'Certificado por',
      item_8: 'Fecha de inicio real'
    }
  },
  english: {
    title: [
      'Block',
      'Description'
    ],
    tabs: {
      overview: 'Overview',
      library: 'Library'
    },
    table: {
      item_0: 'Alias',
      item_1: 'Scheduled start date',
      item_9: 'Scheduled end date',
      item_10: 'Rescheduled start date',
      item_2: 'Rescheduled end date',
      item_3: 'Certification date',
      item_4: 'Delay days',
      item_5: 'Physical execution',
      item_6: 'DSP',
      item_7: 'Certified by',
      item_8: 'Real start date'
    }
  }
}

export const dependenciesModalTranslations = {
  spanish: {
    title: 'Dependencias',
    noData: 'No existen dependencias sin ejecutar para este bloque',
    error: 'Hubo un error buscando las dependencias de este bloque',
    treeTitle: 'Diagrama de dependencias'
  },
  english: {
    title: 'Dependencies',
    noData: 'No dependencies to execute for this block',
    error: 'There was an error searching for dependencies for this block',
    treeTitle: 'Dependency diagram'
  }
}

export const worktableTranslations = {
  spanish: {
    export: {
      action: 'Exportar tabla'
    }
  },
  english: {
    export: {
      action: 'Export table'
    }
  }
}

export const budgetTranslations = {
  spanish: {
    title: 'Gestión de Presupuestos',
    subtitle: 'Cargue archivos de presupuesto por empresa',
    budgetIntegration: {
      label: 'Budget Integration',
      placeholder: 'Seleccione una integración...',
      options: {
        base: 'Base (Bimtrazer)',
        costCode: 'Cost Code',
        wbs: 'WBS',
        budgetCost: 'Budget Cost'
      }
    },
    fileUpload: {
      label: 'Archivo',
      placeholder: 'Seleccione o arrastre un archivo...',
      dropzoneText: 'Arrastre su archivo aquí o haga clic para seleccionar',
      acceptedFiles: 'Archivos permitidos: .xlsx, .csv, .xls, .txt',
      maxSize: 'Tamaño máximo: 10MB'
    },
    buttons: {
      upload: 'Subir Archivo',
      clear: 'Limpiar'
    },
    messages: {
      selectCompany: 'Por favor seleccione una integración de presupuesto',
      selectFile: 'Por favor seleccione un archivo',
      uploadSuccess: 'Archivo subido exitosamente',
      uploadError: 'Error al subir el archivo',
      validationError: 'Error al validar el archivo',
      serverError: 'Error en el servidor. Por favor intente nuevamente.'
    },
    validation: {
      title: 'Etiquetas inválidas encontradas',
      modalMessage: 'La siguiente lista de etiquetas en el archivo no existen en el sistema.',
      columnRow: 'Fila',
      columnAlias: 'Alias'
    }
  },
  english: {
    title: 'Budget Management',
    subtitle: 'Upload budget files by company',
    budgetIntegration: {
      label: 'Budget Integration',
      placeholder: 'Select an integration...',
      options: {
        base: 'Base (Bimtrazer)',
        costCode: 'Cost Code',
        wbs: 'WBS',
        budgetCost: 'Budget Cost'
      }
    },
    fileUpload: {
      label: 'File',
      placeholder: 'Select or drag a file...',
      dropzoneText: 'Drag your file here or click to select',
      acceptedFiles: 'Allowed files: .xlsx, .csv, .xls, .txt',
      maxSize: 'Maximum size: 10MB'
    },
    buttons: {
      upload: 'Upload File',
      clear: 'Clear'
    },
    messages: {
      selectCompany: 'Please select a budget integration',
      selectFile: 'Please select a file',
      uploadSuccess: 'File uploaded successfully',
      uploadError: 'Error uploading file',
      validationError: 'Error validating file',
      serverError: 'Server error. Please try again.'
    },
    validation: {
      title: 'Invalid labels found',
      modalMessage: 'The following labels in the file do not exist in the system.',
      columnRow: 'Row',
      columnAlias: 'Alias'
    }
  }
}
